import { Effect } from "../../Materials/effect";
var name = 'kernelBlurVertex';
var shader = "sampleCoord{X}=sampleCenter+delta*KERNEL_OFFSET{X};";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var kernelBlurVertex = { name: name, shader: shader };
//# sourceMappingURL=kernelBlurVertex.js.map